import { Dialog } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import EditPaymentModalContent from './modal-content'

type Props = {
  visible: boolean
  formInitialValues?: any
  closeModal: () => void
}

const EditPaymentModal = ({ visible, closeModal, formInitialValues }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog
      id="checkoutModal"
      open={visible}
      onClose={closeModal}
      width="small"
      title={t('l.plan_settings.edit.edit_payment_method.title', 'Edit Payment Method')}
      hideXButton={true}
    >
      <EditPaymentModalContent closeModal={closeModal} formInitialValues={formInitialValues} />
    </Dialog>
  )
}

export default EditPaymentModal
